import styled from 'styled-components';

export const CategoryTotalContainer = styled.div`
  display: flex;
  width: 100%;
  height: 70px;
  border-radius: 12px;
  border: 1px solid #4b286d;
`;

export const DescriptionBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 4;
  font-size: 18px;
  font-weight: bold;
  color: #4b286d;
`;

export const ValueBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  flex: 2;
  color: #fff;
  background-color: #4b286d;
  border-top-left-radius: ${props => (props.pos === 'left' ? '12px' : '0px')};
  border-bottom-left-radius: ${props =>
    props.pos === 'left' ? '12px' : '0px'};
  border-top-right-radius: ${props => (props.pos === 'right' ? '12px' : '0px')};
  border-bottom-right-radius: ${props =>
    props.pos === 'right' ? '12px' : '0px'};
`;

export const NumberCurrency = styled.span`
  font-size: 18px;
  font-weight: bold;
  margin: 0px 10px;
`;

export const InputTitle = styled.div`
  margin: 6px 0px;
  font-size: 16px;
  font-weight: bold;
`;

export const Spacer = styled.div`
  height: 20px;
`;

export const InputContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

export const InputPrefix = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 5%;
  margin-bottom: 5px;
  background-color: #f7f7f7;
  border-radius: 2px 0px 0px 2px;
  margin-right: -2px;
  border: 1px solid #e2e2e2;
  font-weight: bold;
`;
